import { render, staticRenderFns } from "./sh.vue?vue&type=template&id=54804feb"
import script from "./sh.vue?vue&type=script&lang=js"
export * from "./sh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports